import { vi } from 'date-fns/locale';

const viCustom = {
  ...vi,
  localize: {
    ...vi.localize,
    day: (n: number, options?: { width?: string }) => {
      const width = options?.width || 'short';
      const values: Record<string, string[]> = {
        narrow: ['C', '2', '3', '4', '5', '6', '7'],
        short: ['C', '2', '3', '4', '5', '6', '7'],
        abbreviated: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
        wide: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
      };
      return values[width][n];
    },
  },
};

export default viCustom;
